import React, { Component } from 'react';
import { Button, Image, OverlayTrigger, Tooltip } from 'react-bootstrap';
import InputField from './Elements/InputField';
import MultiSelect from './Elements/MultiSelect';
import { GET_NETWORK_ICON, baseUrl, capitalizeFirstLetter } from '../../../../../utils';
import TriggerTag from './Elements/TriggerTag';
import { connect } from 'react-redux';
import { FontAwesomeIcon } from '../../../../CommonComponents/AssetsHelper';

const mediaList = [
  {
    id: 1,
    name: "Text",
    imageUrl: baseUrl(`icons/svg-icons/text.svg`)
  },
  {
    id: 2,
    name: "Image",
    imageUrl: baseUrl(`icons/svg-icons/media-1.svg`)
  },
  {
    id: 3,
    name: "Video",
    imageUrl: baseUrl(`icons/svg-icons/video.svg`)
  }
]

const sentimentList = [
  {
    id: 1,
    name: "Postive",
    imageUrl: baseUrl(`icons/svg-icons/pos.svg`)
  },
  {
    id: 2,
    name: "Netural",
    imageUrl: baseUrl(`icons/svg-icons/netural.svg`)
  },
  {
    id: 3,
    name: "Negative",
    imageUrl: baseUrl(`icons/svg-icons/neg.svg`)
  }
]

const recommendationList = [
  {
    id: 1,
    name: "Recommended",
    imageUrl: baseUrl(`icons/svg-icons/recommended.svg`)
  },
  {
    id: 2,
    name: "Considerable",
    imageUrl: baseUrl(`icons/svg-icons/considerable.svg`)
  },
  {
    id: 3,
    name: "Not Recommended",
    imageUrl: baseUrl(`icons/svg-icons/not-recommended.svg`)
  }
]

const getFormatedList = (networks, type) => {
  return networks.map(network => {
    let networkId = type == 1 ? network.id : network.networkId;
    return { ...network, imageUrl: baseUrl(`icons/social-icons-square/${GET_NETWORK_ICON(networkId)}.svg`) }
  });
}

const getTagsList = (tags) => {
  return tags.split(',').map(tag => ({ label: capitalizeFirstLetter(tag), value: tag }))
}

const hideLangFilter = (feedList, languageFeeds) => {
  return feedList.reduce((acc, curr) => {
    if (languageFeeds.split(',').includes(String(curr.id))) acc = true;
    return acc;
  }, false);
}


class Trigger extends Component {

  constructor(props) {
    super(props);
    this.state = {
      langs: []
    }
  }


  render() {
    const { removeTrigger, triggerType, updateValue, triggerIndex, networkList, feedList, tags, languages } = this.props;


    const list = triggerType.triggerType ? triggerType.triggerType < 3 ? triggerType.name == "Sentiment" ? sentimentList : triggerType.name == "AI-Recommendation" ? recommendationList : triggerType.name == "Social Network" ? getFormatedList(networkList, 1) : triggerType.name == "By Feeds" ? getFormatedList(feedList, 2) : mediaList : [] : [];
    const tagList = triggerType.name.includes('Tag') ? tags ? getTagsList(tags) : [] : [];
    const selectedTags = triggerType.name.includes('Tag') ? triggerType.value ? getTagsList(triggerType.value) : [] : [];

    const languageList = triggerType.name.includes('Language') ? languages ? languages : [] : [];
    const selectedLanugae = triggerType.name.includes("Language") ? triggerType.value.length ? getTagsList(triggerType.value) : [] : [];
    const selectedOptions = triggerType.triggerType == 2 ? triggerType.value != '' ? triggerType.value.split(',').map(item => parseInt(item)) : [] : [];


    return <>
      <div className="w-100">
        <div className="d-flex align-items-center rounded-0">
          <div className={`d-flex flex-grow-1 ${triggerType.label ? '' : 'align-items-center'}`}>
            <div className="f-center symbol-30 rounded bg-light me-2">
              <Image src={triggerType.icon} height="16" width="16" />
            </div>
            <div className="text-start">
              <p className={`fs-6 fw-bold mb-0`}>{triggerType.name.includes('Tag') ? 'Add Tags' : triggerType.name}</p>
              {triggerType.label ? <span className="fs-6"><small>{triggerType.label}</small></span> : null}
            </div>
          </div>
          <OverlayTrigger placement="top" overlay={<Tooltip>Remove</Tooltip>}>
            <Button variant='icon' className="p-0 w-30px h-30px btn btn-icon" onClick={removeTrigger}>
              <FontAwesomeIcon type={'regular'} icon={'trash-can'} />
            </Button>
          </OverlayTrigger>
        </div>



        {triggerType.triggerType < 4 ? <div className="mt-2">
          {triggerType.triggerType == 1 ? <InputField inputValue={triggerType.value} inputType={triggerType.icon} triggerIndex={triggerIndex} updateValue={updateValue} /> :
            triggerType.triggerType == 2 ? <MultiSelect triggerIndex={triggerIndex} triggerType={triggerType.name} updateValue={updateValue} optionList={list} selected={selectedOptions} /> :
              triggerType.triggerType == 3 ?
                <TriggerTag triggerType={triggerType} triggerIndex={triggerIndex} updateValue={updateValue} tagsList={triggerType.name == 'Language' ? languageList : tagList} selectedTag={triggerType.name == 'Language' ? selectedLanugae : selectedTags} /> : null}
        </div> : null}

      </div>
    </>
  }
}

const mapStateToProps = (state) => {
  return {
    moderation: state.moderation,
  }
}

export default connect(mapStateToProps, '')(Trigger)